import { memo } from 'react';

import { Button } from 'design-system';
import { Cookie } from 'lucide-react';

const CookieBannerMobile = ({
  handleAccept,
  handleDecline
}: {
  handleAccept: () => void;
  handleDecline: () => void;
}) => {
  return (
    <div className='fixed inset-0 z-[var(--z-floating-anchor)] bg-[rgba(18,22,63,0.80)]'>
      <div className='fixed right-0 bottom-0 left-0 w-full bg-gx-tile-dark px-4 py-6'>
        <div className='flex flex-col justify-center gap-4'>
          <h2 className='flex items-center gap-2 text-xl leading-[30px] font-bold'>
            <Cookie className='size-9' />
            Cookies
          </h2>
          <p>
            To ensure the best experience this application uses cookies as outlined in our{' '}
            <a
              className='underline underline-offset-3 hover:text-gx-highlight'
              href='https://www.general-index.com/privacy-cookies'
              rel='noreferrer'
              target='_blank'
            >
              Privacy Policy
            </a>
            . Cookies are required for the app to work correctly. Declining cookies will disable
            essential features and you won’t be able to use the app. Do you wish to decline cookies?
          </p>
          <Button
            className='h-10 justify-center'
            size='lg'
            onClick={handleAccept}
          >
            <Cookie />
            Accept Cookies
          </Button>
          <Button
            className='h-10 justify-center'
            size='lg'
            variant='outline'
            onClick={handleDecline}
          >
            Decline
          </Button>
        </div>
      </div>
    </div>
  );
};

export default memo(CookieBannerMobile);
